export const SET_COUNT = "SET_COUNT";
export const TOTAL_AUDIT_VS_COMPLETE_AUDIT = "TOTAL_AUDIT_VS_COMPLETE_AUDIT";
export const TOTAL_AUDIT_VS_COMPLETE_AUDIT_LOADER = "TOTAL_AUDIT_VS_COMPLETE_AUDIT_LOADER";
export const COUNT_LEVEL = "COUNT_LEVEL";
export const GRADING_GRAPH = "GRADING_GRAPH";
export const SET_QUERY = "SET_QUERY";
export const RADAR_GRAPH = "RADAR_GRAPH";
export const LEVEL2 = "LEVEL2";
export const LEVEL3 = "LEVEL3";
export const LEVEL4 = "LEVEL4";
export const LEVEL5 = "LEVEL5";